import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useModal } from "../../hooks/useModal.js";
import EditModal from "../editModal/editModal.js";
import { Dropdown } from "react-bootstrap";
import { toast } from "react-toastify";

import "./slotList.css";
import CalendarSlotRow from "../calendarSlotRow/calendarSlotRow.js"
import AvailableTableRow from "../availableSlotRow/availableSlotRow.js";
import SlotForm from "../forms/slotForm.js";
import { useSlots } from "../../hooks/useSlots.js";
import { FaBan, FaCalendarPlus, FaCheckCircle, FaEdit, FaEllipsisV, FaTrashAlt } from "react-icons/fa";

const formatStatusLabel = (status = "") => {
  if (!status) return "Unknown";
  return status.charAt(0).toUpperCase() + status.slice(1);
};

function SlotList({
  selectedDates, availableSlots, removeDate, clearSlots
}) {
  const navigate = useNavigate();

  const { updateSlot, createSlot, deleteSlot } = useSlots();

  const { show: showSlot, close: hideSlot, open: openSlot } = useModal();
  const [ editSlot, setEditSlot]  = useState(null);


  const handleUpdateSlot = async (newSlot) => {
    if (newSlot) {
      try {
        const {id, ...slot} = {...newSlot};
        console.log(slot)

        if (id) {
          const result = await updateSlot({
            id: id,
            slotData: slot,
          });
          console.log('Slot updated:', result);
        } else {
          const result = await createSlot(slot);
          console.log('Slot created:', result);
        }
        
      } catch (error) {
        console.error('Error updating slot:', error);
      }
    }

    hideSlot();
    setEditSlot({});
  }

  const handleSetSlotStatus = async (slot, status) => {
    if (slot.status === status) return;

    try {
      const { id, bookingId, ...slotData } = slot;

      await updateSlot({
        id,
        slotData: {
          ...slotData,
          status,
        },
      });

      toast.success(`Slot marked ${status}.`);
    } catch (error) {
      console.error(`Error making slot ${status}:`, error);
      toast.error(`Could not make this slot ${status}.`);
    }
  };
  
  
  return (
    <div className="slot-list">
      <div className="selected-dates">
        {selectedDates?.map((selectedDate) => {

        const dateSlots = availableSlots
        .filter(slot => slot.date === selectedDate)
        .sort((a, b) => b.priceId - a.priceId);

        console.log("dateSlots", dateSlots);

        const openSlots = dateSlots.filter((slot) => slot.status !== "booked");
        const bookedSlots = dateSlots.filter((slot) => slot.status === "booked");
          
        const formattedDate = new Date(
          parseInt(selectedDate),
        ).toLocaleDateString("en-US", {
          weekday: "long",
          month: "short",
          day: "numeric",
          timeZone: "UTC",
        });

        return (
          <div className="date-container main-border" key={selectedDate}>
            <div className="date-header">
              <div className="date-options">{formattedDate}</div>

              <div className="btn-container">
                <button
                  className="btn remove-btn"
                  onClick={() => {
                    setEditSlot({date: selectedDate});
                    openSlot();
                  }}
                >
                  Add New Slot
                </button>
                <button
                  className="btn remove-btn"
                  onClick={() => removeDate(selectedDate)}
                >
                  X
                </button>
                
              </div>
            </div>
            <div className="tile-container table-responsive">
              {/* for each client unit that also has an available slot */}

              <table className="table slot-table">
                <thead>
                  <tr>
                  <th scope="col">Unit</th>
                  <th scope="col">Name</th>
                  <th scope="col">Time</th>
                  <th scope="col">Slot</th>
                  <th scope="col">Status</th>
                  <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                {bookedSlots.map((slot) => {
                  return (
                    <tr className={"booking-date-row " + slot.status} key={slot.id} onClick={() => navigate(`../booking?booking_id=${slot.bookingId}`)}>
                        <CalendarSlotRow slot={slot} />
                        <td></td>
                    </tr>
                  )
                })}
                {openSlots.map((slot) => {
                  return (
                    // <tr className={"booking-date-row" + (slot.status === "available" ? " available" : " other")} key={slot.id} 
                    // onClick={() => navigate(`../create-booking?slot_id=${slot.id}`)}>
                    //   <AvailableTableRow slot={slot} />
                    // </tr>

                    <tr className={"booking-date-row" + (slot.status === "available" ? " available" : " other")} key={slot.id} >
                      <AvailableTableRow slot={slot} />
                      <td className="text-end">
                        <Dropdown align="end">
                          <Dropdown.Toggle
                            variant="link"
                            bsPrefix="btn"
                            className="slot-action-toggle"
                            aria-label="Open slot actions"
                          >
                            Actions <FaEllipsisV aria-hidden="true" />
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="slot-table-dropdown slot-action-menu">
                            <div className="slot-action-header">
                              <span>Current Status</span>
                              <strong className={`slot-status-pill ${slot.status || "unknown"}`}>
                                {formatStatusLabel(slot.status)}
                              </strong>
                            </div>

                            {slot.status !== "available" && (
                              <Dropdown.Item
                                className="slot-action-item status-action available-action"
                                onClick={() => handleSetSlotStatus(slot, "available")}
                              >
                                <FaCheckCircle aria-hidden="true" />
                                <span>Make Available</span>
                              </Dropdown.Item>
                            )}
                            {slot.status !== "unavailable" && (
                              <Dropdown.Item
                                className="slot-action-item status-action unavailable-action"
                                onClick={() => handleSetSlotStatus(slot, "unavailable")}
                              >
                                <FaBan aria-hidden="true" />
                                <span>Make Unavailable</span>
                              </Dropdown.Item>
                            )}

                            <Dropdown.Divider />

                            <Dropdown.Item
                              className="slot-action-item"
                              onClick={() => navigate(`../create-booking?slot_id=${slot.id}`)}
                            >
                              <FaCalendarPlus aria-hidden="true" />
                              <span>Book</span>
                            </Dropdown.Item>
                            <Dropdown.Item
                              className="slot-action-item"
                              onClick={() => {setEditSlot(slot); openSlot()}}
                            >
                              <FaEdit aria-hidden="true" />
                              <span>Edit</span>
                            </Dropdown.Item>

                            <Dropdown.Divider />

                            <Dropdown.Item
                              className="slot-action-item delete-action"
                              onClick={() => deleteSlot(slot.id)}
                            >
                              <FaTrashAlt aria-hidden="true" />
                              <span>Delete</span>
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  )
                })}
                </tbody>
              </table>
            </div>
          </div>
        )
        })}


      <EditModal title="Slot" show={showSlot} onClose={() => {
          hideSlot();
        }}>
        <SlotForm initialData={editSlot} onSubmit={(newSlot) => handleUpdateSlot(newSlot)} />
      </EditModal>

      </div>
    </div>
  );
}

export default SlotList;
